import SvgIconStyle from 'src/components/SvgIconStyle';

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

export const MENU_ICONS = {
    blog: getIcon('ic_blog'),
    cart: getIcon('ic_cart'),
    chat: getIcon('ic_chat'),
    mail: getIcon('ic_mail'),
    user: getIcon('ic_user'),
    map: getIcon('ic_map'),
    tag: getIcon('ic_nfc'),
    job: getIcon('ic_work'),
    fleet: getIcon('ic_local_shipping'),
    catalog: getIcon('ic_summarize'),
    asset: getIcon('ic_inventory'),
    company: getIcon('ic_business'),
    resources: getIcon('ic_groups'),
    equipment: getIcon('ic_construction'),
    toolkit: getIcon('ic_home_repair_service'),
    kanban: getIcon('ic_kanban'),
    banking: getIcon('ic_banking'),
    calendar: getIcon('ic_calendar'),
    ecommerce: getIcon('ic_ecommerce'),
    analytics: getIcon('ic_analytics'),
    dashboard: getIcon('ic_dashboard'),
    booking: getIcon('ic_booking'),
    setting: getIcon('ic_construction'),
};
